import * as tslib_1 from "tslib";
import { Subject } from 'rxjs/Subject';
var FormlyValueChangeEvent = (function () {
    function FormlyValueChangeEvent(key, value) {
        this.key = key;
        this.value = value;
    }
    return FormlyValueChangeEvent;
}());
export { FormlyValueChangeEvent };
var FormlyEventEmitter = (function (_super) {
    tslib_1.__extends(FormlyEventEmitter, _super);
    function FormlyEventEmitter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormlyEventEmitter.prototype.emit = function (value) {
        _super.prototype.next.call(this, value);
    };
    return FormlyEventEmitter;
}(Subject));
export { FormlyEventEmitter };
var FormlyPubSub = (function () {
    function FormlyPubSub() {
        this.emitters = {};
    }
    FormlyPubSub.prototype.setEmitter = function (key, emitter) {
        this.emitters[key] = emitter;
    };
    FormlyPubSub.prototype.getEmitter = function (key) {
        return this.emitters[key];
    };
    FormlyPubSub.prototype.removeEmitter = function (key) {
        delete this.emitters[key];
    };
    return FormlyPubSub;
}());
export { FormlyPubSub };
//# sourceMappingURL=formly.event.emitter.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng-formly/lib/src/core/src/services/formly.event.emitter.js
// module id = 181
// module chunks = 3